import { PersonPinRounded } from '@mui/icons-material';
import { Box, CircularProgress, IconButton, Tooltip, Typography, useTheme } from '@mui/material';
import { FC } from 'react';

import { BarcodeIcon } from 'src/assets/icons/BarcodeIcon';
import { iconErrorSx, iconWarningSx } from 'src/theme/shared/styles';

import { itemContainer, shortStatsContainerSx } from './styled';
import { ReviewItemsFilterType } from 'src/types/shared';
import { darkTooltipSlotProps } from 'src/theme/shared/tooltip';

type Props = {
  processing?: number;
  requireValidation?: number;
  missingTracking?: number;
  unassigned?: number;
  duplicate?: number;
  iconSize?: number;
  sxMargin?: number;
  onClick?: (option: ReviewItemsFilterType) => void;
  isDark?: boolean;
};

const ReceivedSessionShortStats: FC<Props> = ({
  processing,
  requireValidation,
  missingTracking,
  unassigned,
  duplicate,
  onClick,
  isDark = false,
  iconSize = 20,
  sxMargin = 2,
}) => {
  const size = `${iconSize}px`;
  const iconStyle = { width: size, height: size, fontSize: size };

  const theme = useTheme();

  const onClickFunc = (type: ReviewItemsFilterType) => {
    return onClick ? () => onClick(type) : undefined;
  }

  const Component: any = !onClick ? Box : IconButton;

  const margin = !onClick ? sxMargin : 0;

  const tooltipSlotProps = isDark ? darkTooltipSlotProps(theme) : {};
  
  return (
    <Box sx={shortStatsContainerSx}>
      {!!processing && (
        <>
          <CircularProgress size={iconSize} />
          &nbsp;<Typography sx={{ mr: margin }}>{processing}</Typography>
        </>
      )}
      {!!requireValidation && (
        <Tooltip slotProps={tooltipSlotProps} color="main" title="Require Validation" arrow>
          <Component  onClick={onClickFunc(ReviewItemsFilterType.REQUIRE_VALIDATION)} sx={itemContainer}>
            <PersonPinRounded style={iconStyle} sx={iconWarningSx} />
            &nbsp;<Typography sx={{ mr: margin }}>{requireValidation}</Typography>
          </Component>
        </Tooltip>
      )}
      {!!missingTracking && (
        <Tooltip slotProps={tooltipSlotProps} title="Missing Tracking" arrow>
          <Component onClick={onClickFunc(ReviewItemsFilterType.MISSING_TRACKING_NUMBER)}  sx={itemContainer}>
            <BarcodeIcon style={iconStyle} sx={iconWarningSx} />
            &nbsp;<Typography sx={{ mr: margin }}>{missingTracking}</Typography>
          </Component>
        </Tooltip>
      )}
      {!!unassigned && (
        <Tooltip slotProps={tooltipSlotProps} title="Unassigned" arrow>
          <Component onClick={onClickFunc(ReviewItemsFilterType.UNASSIGNED)}  sx={itemContainer}>
            <PersonPinRounded style={iconStyle} sx={iconErrorSx} />
            &nbsp;<Typography sx={{ mr: margin }}>{unassigned}</Typography>
          </Component>
        </Tooltip>
      )}
      {!!duplicate && (
        <Tooltip slotProps={tooltipSlotProps} title="Duplicate Tracking" arrow>
          <Component onClick={onClickFunc(ReviewItemsFilterType.DUPLICATE)} sx={itemContainer}>
            <BarcodeIcon style={iconStyle} sx={iconErrorSx} />
            &nbsp;<Typography sx={{ mr: margin }}>{duplicate}</Typography>
          </Component>
        </Tooltip>
      )}
    </Box>
  );
};

export default ReceivedSessionShortStats;
